export default __webpack_public_path__ + "static/media/Captain's Belt of the Battlements.6ca689fd.jpg";